import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8 7.5a2.167 2.167 0 1 0 0-4.333A2.167 2.167 0 0 0 8 7.5Zm.167 5.334H4.633c-.786 0-1.373-.694-.972-1.37.58-.982 1.832-2.13 4.506-2.13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.8 11.2h4m-1.6-1.6 1.6 1.6-1.6 1.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);